import {Container} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import useAuth from '../hooks/useAuth';
import { useEffect } from "react";

const Home = () => {
  const navigate = useNavigate();
  const { auth, persist } = useAuth(); 

  useEffect(()=>{
    if(!auth?.accessToken){

      navigate("/dashboard");
  
    }else{
      return (      
        <>       
          <Container className="newcon zoom-in-zoom-out">
               <img src="/images/newlogo.png" width="100%"/>
          </Container>    
        </>
      );
    }
  },[])     
  };
  
  
  //   return (
  //     <>       
  //       <Container className="newcon zoom-in-zoom-out">
  //       <img src="/images/newlogo.png" width="100%"/>
  //         </Container>   
  //     </>
  //   );
  // };

export default Home;